export default [
    {
        path:'/find',
        name:'find',
        component: resolve => require(['../../view/find/find.vue'], resolve),
        meta:{navShow:true}
    },
    {
        path:'/refresh',
        name:'refresh',
        component: resolve => require(['../../view/refresh/refresh.vue'], resolve),
    }
]


// WEBPACK FOOTER //
// ./src/router/find/index.js